const SETTINGS_FIELD_FEATURE_PATHS = {
  historyPointInterval: ["/api/vehicle/history"],
  historyPointDistanceInterval: ["/api/vehicle/history"],
  showStopQRCode: ["/api/stop/qr"],
  mapDetails: ["/api/settings/mapDetails"],
  vehicleIcons: ["/api/settings/icons"],
  stopOriginIcons: ["/api/settings/icons"],
  stopDestinationIcons: ["/api/settings/icons"],
  intermediateStopsIcons: ["/api/settings/icons"],
  chargingPointIcons: ["/api/settings/icons"],
  railwayStationIcons: ["/api/settings/icons"],
};

function normalizeFeaturePath(apiPath = "") {
  const trimmedPath = String(apiPath).trim();
  if (!trimmedPath) {
    return "";
  }
  return trimmedPath.startsWith("/") ? trimmedPath : `/${trimmedPath}`;
}

export function organizationHasFeature(features, requiredPaths) {
  const assignedPaths = new Set(
    (features || []).map((feature) =>
      normalizeFeaturePath(feature?.api_path || feature?.apiPath),
    ),
  );

  return requiredPaths.some((path) => assignedPaths.has(normalizeFeaturePath(path)));
}

export function isSettingsFieldVisible(fieldKey, features) {
  const requiredPaths = SETTINGS_FIELD_FEATURE_PATHS[fieldKey];
  if (!requiredPaths) {
    return true;
  }
  return organizationHasFeature(features, requiredPaths);
}
